import axios from 'axios'

import lodash from './lodash'
import Config from './config';

import {
    DELIVERY_TOKEN_HEADER_KEY
} from "./constants"

function authHeader() {
    return {
        [DELIVERY_TOKEN_HEADER_KEY]: Config.deliveryToken
    }
}

export default {
    getDelivery: (url, config) => {
        let allConfig = {
            headers: authHeader()
        }
        if (config) {
            allConfig = lodash.merge(allConfig, config)
        }
        return axios.get(`${Config.backendDeliveryUrl}/${url}`, allConfig).then(res => {
            console.log(res.request.responseURL)
            return res;
        })
    },
    get: (url, config) => {
        config ? config.headers = lodash.merge(authHeader(), config.headers) : {
            headers: authHeader()
        }
        return axios.get(`${Config.backendUrl}/${url}`, config).then(res => {
            console.log(res.request.responseURL)
            return res;
        })
    },
    getAbsolute: (url) => {
        return axios.get(url).then(res => {
            console.log(res.request.responseURL)
            return res;
        })
    },
    post: (url, body, config) => {
        config ? config.headers = lodash.merge(authHeader(), config.headers) : {
            headers: authHeader()
        }
        return axios.post(`${Config.backendUrl}/${url}`, body, config)
    },
    postPayment: (url, body, config) => {
        config ? config.headers = lodash.merge(authHeader(), config.headers) : {
            headers: authHeader()
        }
        return axios.post(`${Config.paymentBackendUrl}/${url}`, body, config)
    },
    postToAppServer: (body) => {
        return axios.post(Config.appBackendUrl+`users`, body)
    },
    getUserFromAppServer: (email) => {
        return axios.get(Config.appBackendUrl+'users?email=' + email).then(res => {
            return res;
        })
    },
    postAppAddon: (url, body, config) => {
        config ? config.headers = lodash.merge(authHeader(), config.headers) : {
            headers: authHeader()
        }
        return axios.post(`${Config.backendAppSpecificUrl}/${url}`, body, config)
    },
    delete: (url, config) => {
        config ? config.headers = lodash.merge(authHeader(), config.headers) : {
            headers: authHeader()
        }
        return axios.delete(`${Config.backendUrl}/${url}`, config).then(res => {
            console.log(res.request.responseURL)
            return res;
        })
    },
    all: (arrayOfRequests) => {
        return axios.all(arrayOfRequests)
    },
    createCancelSource() {
        return axios.CancelToken.source()
    },
    isCancel() {
        return axios.isCancel
    },

};


